import type {
  FreeDeliverySection,
  FreeDeliverySection_InfoMessage,
  ProgressUntilFreeDeliverySection,
} from "../../../aysa_api/shared/v1/mov.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseFreeDeliverySection = (): FreeDeliverySection => {
  return {};
};

export const decodeFreeDeliverySection = (
  reader: Reader,
  length: number
): FreeDeliverySection => {
  const end = reader.pos + length;
  const message = createBaseFreeDeliverySection();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "progressUntilFreeDeliverySection",
          progressUntilFreeDeliverySection:
            decodeProgressUntilFreeDeliverySection(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "infoMessage",
          infoMessage: decodeFreeDeliverySection_InfoMessage(
            reader,
            reader.uint32()
          ),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeFreeDeliverySection = (
  writer: Writer,
  message: FreeDeliverySection
): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "progressUntilFreeDeliverySection":
        encodeProgressUntilFreeDeliverySection(
          writer.uint32(10).fork(),
          message.type.progressUntilFreeDeliverySection
        ).ldelim();

        break;
      case "infoMessage":
        encodeFreeDeliverySection_InfoMessage(
          writer.uint32(18).fork(),
          message.type.infoMessage
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseFreeDeliverySection_InfoMessage =
  (): FreeDeliverySection_InfoMessage => {
    return {
      text: "",
      backgroundColor: "",
      foregroundColor: "",
    };
  };

export const decodeFreeDeliverySection_InfoMessage = (
  reader: Reader,
  length: number
): FreeDeliverySection_InfoMessage => {
  const end = reader.pos + length;
  const message = createBaseFreeDeliverySection_InfoMessage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.text = reader.string();

        break;
      case 2:
        message.backgroundColor = reader.string();

        break;
      case 3:
        message.foregroundColor = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeFreeDeliverySection_InfoMessage = (
  writer: Writer,
  message: FreeDeliverySection_InfoMessage
): Writer => {
  writer.uint32(10).string(message.text);
  writer.uint32(18).string(message.backgroundColor);
  writer.uint32(26).string(message.foregroundColor);

  return writer;
};

export const createBaseProgressUntilFreeDeliverySection =
  (): ProgressUntilFreeDeliverySection => {
    return {
      freeDeliveryLabel: "",
      amountUntilFreeShipping: "",
      progress: 0,
      moreInfoTitle: "",
      moreInfoDescription: "",
    };
  };

export const decodeProgressUntilFreeDeliverySection = (
  reader: Reader,
  length: number
): ProgressUntilFreeDeliverySection => {
  const end = reader.pos + length;
  const message = createBaseProgressUntilFreeDeliverySection();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.freeDeliveryLabel = reader.string();

        break;
      case 2:
        message.amountUntilFreeShipping = reader.string();

        break;
      case 3:
        message.progress = reader.double();

        break;
      case 4:
        message.moreInfoTitle = reader.string();

        break;
      case 5:
        message.moreInfoDescription = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProgressUntilFreeDeliverySection = (
  writer: Writer,
  message: ProgressUntilFreeDeliverySection
): Writer => {
  writer.uint32(10).string(message.freeDeliveryLabel);
  writer.uint32(18).string(message.amountUntilFreeShipping);
  writer.uint32(25).double(message.progress);
  writer.uint32(34).string(message.moreInfoTitle);
  writer.uint32(42).string(message.moreInfoDescription);

  return writer;
};
